import { render, staticRenderFns } from "./MyContact.vue?vue&type=template&id=18abc53c&scoped=true"
import script from "./MyContact.vue?vue&type=script&lang=js"
export * from "./MyContact.vue?vue&type=script&lang=js"
import style0 from "./MyContact.vue?vue&type=style&index=0&id=18abc53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18abc53c",
  null
  
)

export default component.exports